// extracted by mini-css-extract-plugin
export var actions = "actions_bt71G_HcnUXXiR1M1vzw";
export var auditLogHeader = "audit-log-header_RlfNufz0paK58JdsJM4b";
export var auditLogPagination = "auditLogPagination_nJwVVJknE0XaFRyBg7gW";
export var auditLogSearch = "audit-log-search_Gg6TEJ5WoKZ0tE82HGti";
export var auditLogSeparator = "audit-log-separator_CzaraJzRlbP4uz9mkkDV";
export var auditLogTotalCount = "audit-log-total-count_hv9C6vmeXMAgfCSTiRvf";
export var container = "container_NeknXB9zDWu7tVyUvKkN";
export var detailList = "detail-list_QLVoCR2Y9aL1IX06DAK_";
export var fields = "fields_WdMHJIIzqykWXdyUgUaQ";
export var header = "header_zP4eV10jnRdbf8Armq8Z";
export var idBlock = "id-block_nqEOSZgX6OVJTiYvKI3P";
export var section = "section_mQzd1HFH3edCb4idYeQB";
export var sections = "sections_FVv2Y9bkGmCvnssuzKgP";
export var titleRow = "title-row_aNIme8nCidT5ERskWZDT";
export var vendorLink = "vendor-link_LVrZ9uzWzTq6dfc7dqrd";